import type { GrantPreview } from "@tovi/shared";

/**
 * What a redeemed grant lets a till offer (`#229`), derived from the same
 * preview the choice screen renders — pure and framework-free so the table
 * in the issue is testable without a component harness.
 */

export type ActionChoice = "checkIn" | "take" | "checkInAndTake" | "checkOut";
export type Notice = "noJobs" | "elsewhere";
export type Choice = ActionChoice | Notice;

const NOTICES: ReadonlySet<Choice> = new Set<Notice>(["noJobs", "elsewhere"]);

export function isNotice(choice: Choice): choice is Notice {
  return NOTICES.has(choice);
}

/**
 * Never a combined check-out-and-take button: checking out and taking the
 * till are opposites.
 */
export function choicesFor(preview: GrantPreview): Choice[] {
  if (!preview.timeclock) return ["take"];

  if (preview.openEntry === null) {
    return preview.jobs.length === 0 ? ["take", "noJobs"] : ["checkIn", "take", "checkInAndTake"];
  }

  return preview.openEntry.here ? ["checkOut", "take"] : ["take", "elsewhere"];
}
